export const instagramCommentInitialState = {
  commentsOrRelatedPostComments: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'instagramCommentByPost',
    componentName: 'commentsOrRelatedPostComments',
  },
};
